import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import HelpMessage from "./HelpMessage";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios"; // Import Axios

const AddSubnote = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();

  const { note } = location.state || {}; // Retrieve note data from location state

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [notes, setNotes] = useState(""); // State to hold the notes

  const [fieldData, setFieldData] = useState({
    noteId: id,
  });

  // Get the current date in the specified format
  const currentDate = moment(new Date()).format("DD/MM/YYYY");

  // Get the supplier ID from local storage
  const currentUserSupplierID = localStorage.getItem("currentUser");

  // Function to handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check if notes are not empty before sending the API request
    if (fieldData.notes.trim() === "" ) {
      alert("Notes cannot be empty.");
      return;
    }

    // Prepare the data to be sent to the server
    if (!note || !note.indexkey) {
      alert("Invalid note data. Please try again.");
      return;
    }

    const dataToSave = {
      note: fieldData.notes,
      createddate: fieldData.createddate,
      supplier: note.supplier?.trim() || "",
      parentNoteId: note.Id,
      indexkey: note.indexkey?.trim() || ""
    };

    console.log(note);

    // Make the API request to save the data
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASEURL + "/api/subnote",
        dataToSave,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );
      // Redirect to AdminNotes page after saving
      navigate("/AdminNotes");
      // Scroll to top
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <section className="card">
          <header className="card-header">
            <h1 className="card-title">Add Subnote</h1>
            <p className="card-subtitle">Add a follow-up note to this incident</p>
          </header>

          <form onSubmit={handleFormSubmit} className="form-stack">
            <input defaultValue="0" name="Id" type="hidden" />
            <input name="Indexkey" type="hidden" value={note?.indexkey || ""} />

            <div className="form-grid">
              <div className="form-field">
                <label htmlFor="createdDate">
                  Created Date <span style={{ color: "red" }}>*</span>
                </label>
                <div className="form-field-control">
                  <input
                    id="createdDate"
                    type="text"
                    value={currentDate}
                    disabled
                    style={{
                      backgroundColor: "#f5f5f5",
                      cursor: "not-allowed"
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="form-field">
              <label htmlFor="notes">
                Notes <span style={{ color: "red" }}>*</span>
              </label>
              <div className="form-field-control">
                <textarea
                  id="notes"
                  name="Notes"
                  value={fieldData.notes || ""}
                  onChange={(e) => {
                    setFieldData({
                      ...fieldData,
                      notes: e.target.value
                    });
                  }}
                  maxLength={99}
                  rows={5}
                  style={{
                    width: "100%",
                    borderRadius: "14px",
                    border: "1px solid rgba(20, 34, 58, 0.12)",
                    padding: "12px 16px",
                    fontSize: "15px",
                    fontFamily: "inherit",
                    resize: "vertical",
                    minHeight: "120px"
                  }}
                  placeholder="Enter your note here..."
                />
              </div>
            </div>

            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "24px" }}>
              <button
                type="button"
                className="button ghost"
                onClick={() => {
                  navigate("/Notes/EditNotes", { state: { note: note } });
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="button"
              >
                Save
              </button>
            </div>
          </form>
        </section>

        <div className="home-help">
          <HelpMessage />
        </div>
      </main>
    </div>
  );
};

export default AddSubnote;
